import { render, staticRenderFns } from "./RawDocumentTab.vue?vue&type=template&id=237f91d2&scoped=true"
import script from "./RawDocumentTab.component.js?vue&type=script&lang=js&external"
export * from "./RawDocumentTab.component.js?vue&type=script&lang=js&external"
import style0 from "./RawDocumentTab.vue?vue&type=style&index=0&id=237f91d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f91d2",
  null
  
)

export default component.exports